function getObjLength(_obj: Object) {
  return Object.keys(_obj).length;
}

export {
    getObjLength
}